import moment from 'moment/moment';

import { parseDate } from '@front/common/src/utils/date';
import { validator } from '@front/common/src/forms/validations';

export const validateProBirthDate = (value?: string) => {
  if (!value) return false;

  const date = parseDate(value);
  const age = moment().diff(date, 'years');
  const isAgeValid = age >= 18 && age < 100;

  return date.isValid() && isAgeValid;
};

export const proBirthDateValidator = (inputName: string) =>
  validator<string | undefined>(inputName, 'valid_date', validateProBirthDate);
